import { createFileRoute, redirect } from '@tanstack/react-router';
import { QUOTEMEDIA_EOD_PRICE_JOB_BASE_PATH } from '../../../../../../../../features/vendor/quotemedia/eod-price/job/quotemedia-eod-price-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/')({
  beforeLoad: () => {
    throw redirect({ to: QUOTEMEDIA_EOD_PRICE_JOB_BASE_PATH });
  },
  preload: false,
});
